module.exports = __webpack_public_path__ + "img/wordTwo.08319878.png";